import { Nullable } from '@/types/types';

const durationRegexp = /P(?:(?<years>\d+)Y)?(?:(?<months>\d+)M)?(?:(?<weeks>\d+)W)?(?:(?<days>\d+)D)?(?:T(?:(?<hours>\d+)H)?(?:(?<minutes>\d+)M)?(?:(?<seconds>\d+)S)?)?/;

export type Duration = {
  years:number
  months:number
  weeks:number
  days:number
  hours:number
  minutes:number
  seconds:number
}

export function parseDuration (str:string):Nullable<Duration> {
  const match = durationRegexp.exec(str);
  if (match == null) {
    return null;
  }

  const result: any = match.groups;
  for (const key in result) {
    if (result[key] !== undefined) {
      result[key] = parseInt(result[key]);
    } else {
      result[key] = 0;
    }
  }

  return result as Duration;
}
